import { LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  {
    headerName: 'Site Name',
    field: 'siteName',
    width: LIST_WIDTH.STATUS,
  },
  {
    headerName: 'Pass ID',
    field: 'passName',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'First Name',
    field: 'firstName',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Last Name',
    field: 'lastName',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Visitor Type',
    field: 'type',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Purpose of visit',
    field: 'purpose',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Destination',
    field: 'destination',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  {
    headerName: 'Phone',
    field: 'phone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  {
    headerName: 'Vehicle Registration',
    field: 'vehicleRegistration',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Sign in time',
    field: 'accessTime',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Sign out time',
    field: 'egressTime',
    width: LIST_WIDTH.TIME_DATE,
  },
];
